// extracted by mini-css-extract-plugin
module.exports = {"slider-menu":"cart-slider-menu_slider-menu__p2jQ4","slider-menu-container":"cart-slider-menu_slider-menu-container__7DUGX","cta-button":"cart-slider-menu_cta-button__ogKhT"};